import { useContext } from "react";
import { StyleContext } from "../context/DialogStyleContext.js";
const useDialogStylesContext = ()=>useContext(StyleContext);
export { useDialogStylesContext };
